import { EventAdapter } from '~analytics/adapters/EventAdapter';
import { sendTeacherAmplitudeEvent } from '~analytics/amplitude';
import { EventTypes, RoomTypes } from '~analytics/types';

interface DeleteRoomEventAdapterParams {
  roomType: RoomTypes;
}

type DeleteRoomEventData = {
  room_type: RoomTypes;
};

export class DeleteRoomEventAdapter extends EventAdapter<DeleteRoomEventData> {
  protected intercomEventKey = null;

  constructor({ roomType }: DeleteRoomEventAdapterParams) {
    super();

    this.eventData = {
      room_type: roomType,
    };
  }
  protected amplitudeEventFunction = function sendDeleteRoomEvent(
    event: DeleteRoomEventData
  ) {
    sendTeacherAmplitudeEvent(EventTypes.DeleteRoom, event);
  };
}
